<template>
  <div class="card p-2" style="min-height: calc(100vh  - 185px);">
    <div class="d-flex flex-wrap justify-content-between align-item-center">
      <h3>Sales Register</h3>
      <button
          @click="navigateToListPage()"
          class="btn btn-close"
      >
      </button>
    </div>
    <section id="basic-tabs-components">
      <div class="row match-height">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <ul class="nav nav-tabs" id="myTab" role="tablist">
                <li class="nav-item">
                  <a @click="onChangeTab('invoice')" :class="{ active: activeTab === 'invoice' }" class="nav-link" id="home-tab-fill" data-bs-toggle="tab" href="#invoice-tab" role="tab" aria-controls="invoice-tab" aria-selected="false">Invoice Wise</a>
                </li>
                <li class="nav-item">
                  <a @click="onChangeTab('item')" :class="{ active: activeTab === 'item' }" class="nav-link" id="item-tab-fill" data-bs-toggle="tab" href="#item-tab" role="tab" aria-controls="item-tab" aria-selected="false">Item Wise</a>
                </li>
                <li class="nav-item">
                  <a @click="onChangeTab('customer')" :class="{ active: activeTab === 'customer' }" class="nav-link" id="customer-tab-fill" data-bs-toggle="tab" href="#customer-tab" role="tab" aria-controls="customer-tab" aria-selected="false">Customer Wise</a>
                </li>
              </ul>
              <hr>

              <div class="tab-content">
                <div :class="{ 'show active': activeTab === 'invoice' }" class="tab-pane" id="invoice-tab" role="tabpanel" aria-labelledby="invoice-tab-fill">
                   <InvoiceTab 
                      v-if="activeTab === 'invoice'"
                      :business-list="businessList"
                      :project-list="projectList"
                      :home-data="homeData"
                   />
                </div>
                <div :class="{ 'show active': activeTab === 'item' }" class="tab-pane" id="item-tab" role="tabpanel" aria-labelledby="item-tab-fill">
                   <ItemTab 
                      v-if="activeTab === 'item'"
                      :project-list="projectList"
                      :home-data="homeData"
                   />
                </div>
                <div :class="{ 'show active': activeTab === 'customer' }" class="tab-pane" id="customer-tab" role="tabpanel" aria-labelledby="customer-tab-fill">
                   <CustomerTab 
                      v-if="activeTab === 'customer'"
                      :home-data="homeData"
                   />
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </section>
    <hr>
    <Loader v-if="loading"/>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useStore } from 'vuex';
import Loader from '@/components/atom/LoaderComponent'
import InvoiceTab from '@/components/molecule/company/inventory/product-sales-register/InvoiceTab.vue'
import ItemTab from '@/components/molecule/company/inventory/product-sales-register/ItemTab.vue'
import CustomerTab from '@/components/molecule/company/inventory/product-sales-register/CustomerTab.vue'
import {useRoute, useRouter} from "vue-router";
import handleDropdowns from "@/services/modules/dropdowns";

const loading = ref(false)
const route = useRoute()
const router = useRouter()
const store = useStore()
const { fetchDropdownList } = handleDropdowns();
const businessList = ref([]);
const projectList = ref([]);
const homeData = ref({});

const activeTab = ref(route.query.tab || 'invoice');

const onChangeTab = async (tab) => {
  store.commit('resetPagination');
  const query = Object.assign({}, route.query);
  query.page = 1;
  query.tab = tab;
  await router.push({ path: route.path, query });
  activeTab.value = tab;
}

function navigateToListPage() {
  const query = Object.assign({}, route.query)
  delete query.visit_client_id;
  delete query.type;

  router.push({
    name:route.query.type === 'approval'
        ? 'sales-order-approval'
        : (route.query.type === 'order-sales'
            ? 'order-sales'
            : 'sales-order-list'),
    params: route.params, query: query
  })
}

onMounted(async () => {
  loading.value = true;
  const consolidatedQuery = `?company_id=${route.params.companyId}&is_business=1&is_home=1&is_project=1&with_donors=1`;
  
  await fetchDropdownList(consolidatedQuery).then(res => {
    if (res.status && res.data) {
      businessList.value = res.data.business_list;
      projectList.value = res.data.project_list;
      homeData.value = res.data.home_data;
    }
  }).catch(err => {
    console.error(err);
  }).finally(() => {
    loading.value = false;
  });
})
</script>
